// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"876":"a639bfff","2447":"378fd679","3480":"4a081cb3","4276":"378fd679"}[chunkId] + ".chunk.css";
};